import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import DropDown from '../Dropdown/DropDown';

import { sectionEdit } from '../../../../../Store/api/professor/settings';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './section.css';
import { setActiveTab } from '../../../../../Store/ui/classTabs';
import { toast } from 'react-toastify';
import ArrowRight from '../../../../../assets/images/Arrow-right-dark.svg';

const Section = ({ section, classDetails, setRefetch }) => {
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [sectionInformation, setSectionInformation] = useState(section);

  useEffect(() => {
    setSectionInformation(section);
  }, [section]);

  return (
    <div className='box_border_settings'>
      <div className='settings_header'>
        <h2>
          {sectionInformation.sectionName} {sectionInformation.sectionNumber.split('-')[0]}
        </h2>
        <h2 className='theme_para cursor'>
          <CopyToClipboard
            text={`${window.location.origin}/section/${sectionInformation.joinCode}`}
            onCopy={() => {
              setCopied(true);
              setTimeout(() => {
                setCopied(false);
              }, 1500);
            }}
          >
            <div className='fs-14 text-lowercase text-grey-800 fw-500 text-decoration-underline'>
              {!copied && <>{`${window.location.origin}/section/${sectionInformation.joinCode}`}</>}
              {copied && (
                <div className='d-flex align-items-center'>
                  <img src='/assets/images/linke.png' alt='link icon' width={15} height={12} />
                  <span className='ms-1 text-uppercase'>C</span>opied
                </div>
              )}
            </div>
          </CopyToClipboard>
        </h2>
        <div className='settings_header'>
          <p className='mb-0 delette cursor'>Delete</p>
          <div className='mb-0 editt cursor d-flex align-items-center'>
            <p className={`text-uppercase mb-0 ${isEditing ? 'text-decoration-none' : ''}`} onClick={() => setIsEditing((old) => !old)}>
              {isEditing ? 'editing' : 'edit'}
            </p>
          </div>
        </div>
      </div>
      <div className='section_row align-items-center'>
        <p className='mb-0 sect_el'>Primary instructor</p>
        <p className='mb-0 sect_el'>{sectionInformation?.instructorEmails?.filter((e) => e.isPrimary)?.length ? sectionInformation?.instructorEmails?.filter((e) => e.isPrimary)[0].email : sectionInformation?.instructorEmails[0]?.email}</p>
        {isEditing ? (
          <div className='sect_el'>
            <DropDown
              title={'Select One'}
              onClick={(e) => {
                setSectionInformation((old) => {
                  return {
                    ...old,
                    instructorEmails: old?.instructorEmails?.map((inst) => {
                      return {
                        ...inst,
                        isPrimary: inst.email === e.target.value,
                      };
                    }),
                  };
                });
              }}
              options={sectionInformation?.instructorEmails?.map((inst) => ({
                title: inst.email,
                isChecked: inst.isPrimary,
                value: inst.email,
              }))}
              type={'radio'}
              name={sectionInformation._id}
              htmlFor={sectionInformation._id}
            />
          </div>
        ) : (
          <div className='sect_el'></div>
        )}
      </div>
      <div className='section_row align-items-center'>
        <p className='mb-0 sect_el'>Additional instructors</p>
        <p className='mb-0 fw-500 grey_900 sect_el'>
          {section.instructorEmails
            .filter((e) => !e.isPrimary)
            .map((e) => e.email)
            .join(', ')}
        </p>
        {isEditing ? (
          <div className='sect_el'>
            <DropDown
              title={'Select Multiple'}
              onChange={(e) => {
                if (!e.target.checked && sectionInformation.instructorEmails.length === 1) {
                  return;
                }
                setSectionInformation((old) => {
                  return {
                    ...old,
                    instructorEmails: old.instructorEmails.some((l) => l.email === e.target.value) ? old.instructorEmails.filter((em) => em.email !== e.target.value) : [...old.instructorEmails, { email: e.target.value, isPrimary: false }],
                  };
                });
              }}
              options={classDetails?.instructors?.map((inst) => ({
                title: inst,
                isChecked: sectionInformation.instructorEmails.some((e) => e.email === inst),
                value: inst,
              }))}
              type={'checkbox'}
            />
          </div>
        ) : (
          <div className='sect_el'></div>
        )}
      </div>
      {isEditing && (
        <div className='setting_rows' style={{ marginBottom: '0px', marginTop: '16px' }}>
          <p className='key'></p>
          <p className='value'>
            <p className='main_part'></p>
            <p
              style={{ fontWeight: 500, fontSize: 14, color: 'black' }}
              className='edit_buttton cursor'
              onClick={() => {
                dispatch(
                  sectionEdit({
                    id: sectionInformation._id,
                    body: {
                      instructorEmails: sectionInformation.instructorEmails.filter((e) => !(e.hasOwnProperty('isChecked') && !e.isChecked)).map((e) => e.email),
                    },
                    onSuccess: (res) => {
                      dispatch(setActiveTab('settings'));
                      setRefetch(true);
                      setIsEditing(false);
                    },
                    onError: (error) => {
                      const msg = error.response && error.response.data ? error.response.data.message : 'Unknown error!!.';
                      toast.error(msg);
                    },
                  })
                );
              }}
            >
              Save <img src={ArrowRight} alt='save' />
            </p>
          </p>
        </div>
      )}
    </div>
  );
};

export default Section;
